import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    card: {
        backgroundColor: '#ffffff',
        border: '1px solid #E4E7EC',
        borderRadius: 8,
        padding: '40px 48px',
    },
    heading: {
        marginBottom: 26,
        letterSpacing: '-0.01em',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
        gap: 28,
    },
    itemQuestion: {
        marginBottom: 8,
        fontWeight: 600,
    },
    itemAnswer: {
        color: theme.palette.text.secondary,
    },
}));
